import { useState, useEffect, useContext } from 'react'

import resizeObserverContext from './resize-observer-context'
import {
  MAX_MOBILE_WIDTH,
  MAX_TABLET_WIDTH,
  MAX_DESKTOP_WIDTH,
  MAX_WIDTH_FOR_MOBILE_ASSETS
} from './client-constants'

export interface Breakpoint {
  isMobile: boolean
  isTablet: boolean
  isDeskTop: boolean
  isLargeScreen: boolean
  useMobileAssets: boolean
  screenSize: number
}

const getDeviceType = (screenSize: number): Breakpoint => {
  const isMobile = screenSize <= MAX_MOBILE_WIDTH
  const isTablet =
    screenSize > MAX_MOBILE_WIDTH && screenSize <= MAX_TABLET_WIDTH
  const isDeskTop =
    screenSize > MAX_TABLET_WIDTH && screenSize <= MAX_DESKTOP_WIDTH
  const isLargeScreen = screenSize > MAX_DESKTOP_WIDTH
  const useMobileAssets = screenSize <= MAX_WIDTH_FOR_MOBILE_ASSETS

  return {
    isMobile,
    isTablet,
    isDeskTop,
    isLargeScreen,
    useMobileAssets,
    screenSize
  }
}

const useBreakpoint = (): Breakpoint => {
  const screenSize = useContext(resizeObserverContext)
  //*Default SSR breakpoint is desktop
  const [breakpoint, setBreakpoint] = useState({
    isMobile: false,
    isTablet: false,
    isDeskTop: true,
    isLargeScreen: false,
    useMobileAssets: false,
    screenSize: 1024
  })
  /*On SSR there is no viewport height or width. On SSR default breakpoint is desktop.
  But once page is in client side we want these breakpoints to be calculated based on client device
  componentDidMount lifecycle only gets triggered on client side. isFirstRender state was added to detect
  this client render and based on this to update breakpoint state based client device*/
  const [isFirstRender, setIsFirstRender] = useState(true)
  useEffect(() => {
    setIsFirstRender(false)
  }, [])

  useEffect(() => {
    if (!isFirstRender) {
      setBreakpoint(getDeviceType(screenSize))
    }
  }, [screenSize, isFirstRender])

  return breakpoint
}

export default useBreakpoint
